import React from 'react'
import Text from 'particles/Text'
import { menuItemClasses } from '@mui/material/MenuItem'
import { BaseMenuItemProps } from '.'
import styled from 'particles/themes/styled'
import { StyledBaseMenuItem } from './style'
import IconButton from 'particles/Button/IconButton'
import Tooltip from 'particles/Tooltip'

interface MenuItemProps extends BaseMenuItemProps {
    description?: string
    img: JSX.Element
    isDisabled?: boolean
}

const StyledMenuItem = styled(StyledBaseMenuItem)`
    &.${menuItemClasses.root} {
        padding: 8px;
        align-items: flex-start;
        align-self: stretch;
        gap: ${({ theme }) => theme.spacing[200]};
        @media screen and (max-width: 768px) {
            min-height: auto;
        }
        &.${menuItemClasses.focusVisible} {
            border: 3px solid ${({ theme }) => theme.colors.border.actionFocus};
            padding: 5px;
            background-color: transparent;
            width: 100%;
        }
        .menu-item-area {
            display: flex;
            flex-direction: column;
            gap: ${({ theme }) => theme.spacing[100]};
        }
        .img {
            height: 42px;
            width: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: ${({ theme }) => theme.colors.background.primary};
            border-radius: 4px;
            flex-shrink: 0;
        }
        .text {
            white-space: pre-wrap;
            word-break: break-word;
        }
    }
`

const MenuItemImg: React.FC<MenuItemProps> = ({ title, description, img, isDisabled, tooltipContext, ...props }) => {
    return (
        <StyledMenuItem {...props} disabled={isDisabled} disableRipple>
            {img && <div className="img">{img}</div>}
            <div className="menu-item-area">
                <Text scale="bodyS700" {...(isDisabled && { color: 'disable' })} className="text">
                    {title}
                </Text>
                <Text scale="bodyS400" color={isDisabled ? 'disable' : 'secondary'} className="text">
                    {description}
                </Text>
            </div>
            {isDisabled && (tooltipContext?.label || tooltipContext?.title) && (
                <Tooltip {...tooltipContext} onClick={e => e.stopPropagation()}>
                    <IconButton size="xs" color="neutral" form="icon" icon="question" className="tooltip" />
                </Tooltip>
            )}
        </StyledMenuItem>
    )
}

export default MenuItemImg
